/* eslint-disable no-undef */
/* eslint-disable no-console */

document.addEventListener("DOMContentLoaded", () => {
	new Mmenu("#mobile-menu", {
		slidingSubmenus: false,
		pageScroll: true,
		extensions: [
			"pagedim-black",
			"position-right",
			"position-front",
			"theme-dark",
		],
		counters: false,
		onClick: {
			close: true,
		},
		navbars: [
			{
				position: 'top',
				content: [
					'prev',
					'',
					'close'
				],
			},
		],
	});
});


(function ($) {

	$(function () {

		// console.log(
		// 	"Width: " +
		// 	window.innerWidth +
		// 	", Height: " +
		// 	window.innerHeight
		// );

		// https://stackoverflow.com/a/49260411
		// Make numbers animate when user scrolls and reach a div
		var section = document.querySelector('.numbers');
		var hasEntered = false;
		window.addEventListener('scroll', (e) => {
			var shouldAnimate = (window.scrollY + window.innerHeight) >= section.offsetTop;

			if (shouldAnimate && !hasEntered) {
			hasEntered = true;

			$('.value').each(function () {
				$(this).prop('Counter',0).animate({
				Counter: $(this).text()
				}, {
				duration: 4000,
				easing: 'swing',
				step: function (now) {
					$(this).text(Math.ceil(now));
				}
				});
			});

		}
		});

	});

	$(window).on('load', function () {

	});

})(jQuery);
